export const API_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3000'
    : 'https://api.zapisy.wydarzenia.napwr.pl'
